/**
 * AI Contents services (batch generation of images and videos)
 */

import api, { uploadFile } from './api-wrapper';

const CONTENTS_BASE = '/api/v4/ai/contents';

/**
 * Helper to extract response when it is needed
 */
const unwrapResponse = (response) => response?.response ?? response;

// Catalog
export const getContentModels = () => api.get(`${CONTENTS_BASE}/models/`).then(unwrapResponse);

// Requests (batches)
export const getContentRequests = (params = {}) => api.get(`${CONTENTS_BASE}/requests/`, { params }).then(unwrapResponse);
export const estimateContentRequest = (data) => api.post(`${CONTENTS_BASE}/requests/estimate/`, data).then(unwrapResponse);
export const createContentRequest = (data) => api.post(`${CONTENTS_BASE}/requests/`, data).then(unwrapResponse);
export const getContentRequest = (uuid) => api.get(`${CONTENTS_BASE}/requests/${uuid}/`).then(unwrapResponse);

// References (user photos reused across batches)
export const getContentReferences = (params = {}) => api.get(`${CONTENTS_BASE}/references/`, { params }).then(unwrapResponse);
export const uploadContentReferences = (files, kind) => {
  const form_data = new FormData();
  files.forEach((file) => form_data.append('files', file));
  if (kind) form_data.append('kind', kind);
  return uploadFile(`${CONTENTS_BASE}/references/`, form_data).then(unwrapResponse);
};
